module.exports = __webpack_public_path__ + "media/fonts/fontawesome-webfont-b048c7e641eda9ad4a69d281fc8aa3bd.ttf";